<template>
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.30371 11L3.30371 6.00002L4.00371 5.30002L8.30371 9.60002L12.6037 5.30002L13.3037 6.00002L8.30371 11Z"
      fill="var(--color, #7D89B0)"
    />
  </svg>
</template>
